import { render, staticRenderFns } from "./adminId.vue?vue&type=template&id=5abb2916&"
import script from "./adminId.vue?vue&type=script&lang=js&"
export * from "./adminId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports